import { forwardRef, type Ref, type SVGProps } from "react";
const IconFilterFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M9 4a2 2 0 1 0-4 0v5H4a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4H9zm18 0a2 2 0 1 0-4 0v5h-1a2 2 0 1 0 0 4h6a2 2 0 1 0 0-4h-1zM16 30a2 2 0 0 1-2-2v-5h-1a2 2 0 1 1 0-4h6a2 2 0 1 1 0 4h-1v5a2 2 0 0 1-2 2m11-12a2 2 0 1 0-4 0v10a2 2 0 1 0 4 0zM7 16a2 2 0 0 1 2 2v10a2 2 0 1 1-4 0V18a2 2 0 0 1 2-2m7-1a2 2 0 1 0 4 0V4a2 2 0 1 0-4 0z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFilterFilledSVG);
ForwardRef.displayName = "IconFilterFilled";
export { ForwardRef as IconFilterFilled };
